<template>
  <DefaultLayout
    :pageProps="{
      title: 'Reset your password',
    }"
  >
    <template #content>
      <ForgotPassword />
    </template>
  </DefaultLayout>
</template>

<script>
import ForgotPassword from "@/components/forms/ForgotPassword";
import DefaultLayout from "../../layout/DefaultLayout.vue";

export default {
  name: "index.vue",
  components: {
    DefaultLayout,
    ForgotPassword,
  },
};
</script>
